<template>
  <div v-if="!loading">
    <h1 class="main-header">
      <translate translate-context="chargebackType" :translate-params="{id: chargebackType.id, code: chargebackType.code}">
        Edit Dispute Type #%{id} - %{code}
      </translate>
    </h1>
    <ChargebackTypeForm :data="chargebackType" @save="onSave" :save_text="$pgettext('form', 'Save')"/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {RecordNotFound, SuccessNotification} from "@/domain/core/exception/exceptions";
import ChargebackTypeForm from "@/domain/chargebackType/components/ChargebackTypeForm.vue";

export default {
  name: 'EditChargebackType',
  components: {ChargebackTypeForm},
  data() {
    return {
      loading: true,
    }
  },
  async mounted() {
    try {
      await this.fetchChargebackType(this.$route.params.id)
    } catch (e) {
      if (e instanceof RecordNotFound) {
        await this.$router.push({name: 'chargebackType.list'})
      }
    }
    this.loading = false
  },
  computed: {
    ...mapGetters('chargebackType', ['chargebackType']),
  },
  methods: {
    ...mapActions('chargebackType', ['fetchChargebackType', 'updateChargebackType']),

    async onSave(data) {
      await this.updateChargebackType({id: this.chargebackType.id, data: data})
      await this.$router.push({name: 'chargebackType.list'})
      throw new SuccessNotification(this.$pgettext('chargebackType', 'Dispute type updated!'))
    }
  }
}
</script>
